import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { Link } from 'foundations-components/transitional/components/Link';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import LearnMoreModal from '../base/LearnMoreModal';
import { useModalTracker } from '../../../hooks/tracking';
import { ACADEMY_LESSON_CONNECT_TEAM_EMAIL_URL, KNOWLEDGE_BASE_CONNECT_TEAM_EMAIL_URL } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConnectTeamEmailModal = ({
  onClose
}) => {
  const {
    trackLink
  } = useModalTracker('ConnectTeamEmailModal');
  return /*#__PURE__*/_jsxs(LearnMoreModal, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.connectTeamEmail.heading"
    }),
    illustrationName: "team",
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.connectTeamEmail.description"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.connectTeamEmail.p1"
      })
    }), /*#__PURE__*/_jsx(KnowledgeBaseButton, {
      onClick: () => trackLink('connect team email article'),
      url: KNOWLEDGE_BASE_CONNECT_TEAM_EMAIL_URL,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.readInstructions"
      })
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: ACADEMY_LESSON_CONNECT_TEAM_EMAIL_URL,
      onClick: () => trackLink('connect team email lesson'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.watchVideo"
      })
    })]
  });
};
ConnectTeamEmailModal.propTypes = {
  onClose: PropTypes.func
};
export default ConnectTeamEmailModal;